import { lang } from '../../assets/lang'
import { delayHtml } from '../../data/modal/delayHtml'

const isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon

export let otnSingleHtml =
'<div class="form-group text-left mt-2">' +
  '<label for="template-name">' + lang.otn_single_html_template_name + '</label>' +
  '<input type="text" id="template-name" class="form-control">' +
'</div>' 

if(isSequenceAddonAvailable){
  otnSingleHtml += 
  '<div class="form-row">'+
    '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field col">' +
      '<div class="d-flex justify-content-between">' +
        '<label for="new-button-choose-label">' + lang.button_html_add_label + '</label>' +
        '<span class="text-small text-primary text-underline" data-toggle="tooltip" data-original-title="' + lang.postback_html_label_create_new_info + '"><i class="fas fa-plus-circle"></i> ' + lang.postback_html_label_create_new + '</span>' +
      '</div>' + 
      '<select id="new-button-choose-label" class="form-control select2" multiple="">' +
      '</select>' +
    '</div>' +

    '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field col">' +
      '<div class="d-flex justify-content-between">' +
        '<label for="new-button-remove-label">' + lang.button_html_remove_label + '</label>' +
      '</div>' + 
      '<select id="new-button-remove-label" class="form-control select2" multiple="">' +
      '</select>' +
    '</div>' +
  '</div>' +
  '<div class="form-row">'+
    '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field col">' +
      '<label for="new-button-choose-sequence">' + lang.button_html_add_sequence + '</label>' +
      '<select id="new-button-choose-sequence" class="form-control select2">' +
      '</select>' +
    '</div>' +

    '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field col">' +
      '<label for="new-button-remove-sequence">' + lang.button_html_remove_sequence + '</label>' +
      '<select id="new-button-remove-sequence" class="form-control select2">' +
      '</select>' +
    '</div>' +
  '</div>' +

  '<div class="form-row">'+
    '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field col">' +
      '<label for="new-button-conversation-group">' + lang.button_html_conversation_group + '</label>' +
      '<select id="new-button-conversation-group" class="form-control select2">' +
      '</select>' +
    '</div>' +

    '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field col">' +
      '<label for="new-button-conversation-user">' + lang.button_html_conversation_user + '</label>' +
      '<select id="new-button-conversation-user" class="form-control select2">' +
      '</select>' +
    '</div>' +
  '</div>' +

  '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field">' + 
    '<label for="new-button-webhook-url">' + lang.button_html_label_webhook_url + '</label>' +
    '<input type="text" class="form-control" id="new-button-webhook-url" aria-describedby="button-button-text-help">' +
  '</div>' 
}

// Adds html for delay system
// delayHtml
